import { RealTimeUpdatesScreen } from '@/screens/name-screen/RealTimeUpdatesScreen'

export default function () {
  return <RealTimeUpdatesScreen />
}
